export const AttestationRecordStatus = {
  Attested: 'attested',
  Expired: 'expired',
  NotAttested: 'not_attested',
  NotRequired: 'not_required',
  // `overdue` is a real lookup value in risksmart.attestation_record_status
  // (seeded by 1770819947863_add_attestation_overdue_view): a record persisted
  // as pending whose ExpiresAt has passed is surfaced as overdue. The my-items
  // ribbon read filters AttestationStatus IN (pending, overdue) (RSP-6214).
  Overdue: 'overdue',
  Pending: 'pending',
} as const;

export type AttestationRecordStatus =
  (typeof AttestationRecordStatus)[keyof typeof AttestationRecordStatus];
